import styled from 'styled-components';
import colors from 'common/styles/colors';
import { titleBarVariables } from 'common/styles/titleBar';

// The help / admin / avatar actions now live in flow inside the title bar's Tier 1
// (see BreadCrumbHeader `globalActions`), so they no longer need fixed positioning here.
// The bar's measured height is published here for the layouts below it (common/styles/titleBar).
const HomePageContainer = styled.div`
  ${props => titleBarVariables(props.titleBarHeight)}
  background: ${props => props.theme.colors.backgroundGray};

  .ui.menu.vertical {
    box-shadow: none;
  }

  /* fallback for a partner theme without a primaryColor (the icons set it inline) */
  #admin,
  #help {
    color: ${colors.green};
  }

  .ui.active.visible.item {
    z-index: 1000;
  }
`;

export default HomePageContainer;
